export default __webpack_public_path__ + "static/Managed-Normal-67799c2b42f25d6e4fddc5008816550d.svg";